/* Produkt-Slider mit Wellen-Regler (custom_slider_luki).
   Seit 24.10.2026 ohne jQuery und INP-schonend (Clarity meldete hohe INP):
   - Loslassen irgendwo auf der Seite rechnet nur noch, wenn DIESER Slider gezogen wurde.
     Vorher hat jedes Tippen alle Slider neu ausgemessen und verschoben.
   - Ein einfacher Tipp auf ein Bild loest kein Einrasten/Zentrieren mehr aus.
   - Bildbreite wird zwischengespeichert, Regler-Updates laufen gebuendelt per requestAnimationFrame.
   Verhalten (Ziehen am Regler, Wischen, Einrasten, aktives Bild) ist unveraendert. */
(function () {
  function start() {
    document.querySelectorAll('.custom-slider-container').forEach(initSlider);
  }

  function initSlider(container) {
    if (container.dataset.sliderReady) return;
    container.dataset.sliderReady = '1';

    var handle = container.querySelector('.handle');
    var fullPath = container.querySelector('.full-path');
    var coloredPath = container.querySelector('.colored-path');
    var imagesWrapper = container.querySelector('.images-wrapper');
    var imagesContainer = container.querySelector('.images-container');
    if (!handle || !fullPath || !imagesWrapper || !imagesContainer) return;
    /* Startseite am Handy: kleine Karten, natives Wischen (CSS in sections/custom_slider_luki.liquid) */
    if (container.closest('.melf-slider-klein') && window.innerWidth < 750) return;
    var images = Array.prototype.slice.call(imagesWrapper.children);
    if (!images.length) return;

    var pathLength = fullPath.getTotalLength();
    var visibleImages = 4;
    var isDraggingSlider = false;
    var isDragging = false;
    var initialMouseX = 0;
    var initialHandleCX = 0;
    var currentTranslate = 0;
    var prevTranslate = 0;
    var currentIndex = 0;
    var isTouchSwiping = false;
    var touchStartX = 0;
    var touchStartY = 0;
    var activeTimeout = null;
    var THRESHOLD = 1;
    var clickPrevented = false;
    var animationFrame = null;
    var reglerFrame = null;
    var bildBreite = 0;

    imagesWrapper.style.willChange = 'transform';
    handle.style.willChange = 'transform';

    function emSize() { return parseFloat(getComputedStyle(document.documentElement).fontSize); }
    function istMobil() { return window.innerWidth <= 48 * emSize(); }

    /* entspricht jQuery outerWidth(true): Breite plus Aussenabstaende, einmal pro Groessenaenderung */
    function messeBildBreite() {
      var cs = getComputedStyle(images[0]);
      bildBreite = images[0].offsetWidth + parseFloat(cs.marginLeft) + parseFloat(cs.marginRight);
    }
    function maxScroll() { return (images.length - visibleImages + 1) * bildBreite; }

    function updateVisibleImages() {
      var em = emSize();
      visibleImages = window.innerWidth <= 30 * em ? 1.5 : window.innerWidth <= 48 * em ? 2 : 4;
    }

    function setzeRegler(length) {
      var point = fullPath.getPointAtLength(length);
      handle.setAttribute('cx', point.x);
      handle.setAttribute('cy', point.y);
      if (coloredPath) coloredPath.setAttribute('stroke-dasharray', length + ', ' + pathLength);
    }

    function updateSliderHandle() {
      if (reglerFrame) return;
      reglerFrame = requestAnimationFrame(function () {
        reglerFrame = null;
        var max = maxScroll();
        var length = max > 0 ? Math.min(pathLength, (Math.abs(currentTranslate) / max) * pathLength) : 0;
        setzeRegler(length);
      });
    }

    function updateHandlePosition(deltaX) {
      var rect = fullPath.getBoundingClientRect();
      var offsetX = Math.max(0, Math.min(initialHandleCX + deltaX - rect.left, rect.width));
      var length = pathLength * offsetX / rect.width;
      setzeRegler(length);
      var max = maxScroll();
      var scrollPosition = Math.min(max, max * length / pathLength);
      imagesWrapper.style.transform = 'translateX(-' + scrollPosition + 'px)';
      prevTranslate = -scrollPosition;
      currentTranslate = -scrollPosition;
      currentIndex = Math.round(Math.abs(currentTranslate) / bildBreite);
    }

    function updateImagesPosition(deltaX) {
      var scrollPosition = Math.max(-maxScroll(), Math.min(0, prevTranslate + deltaX));
      imagesWrapper.style.transform = 'translateX(' + scrollPosition + 'px)';
      currentTranslate = scrollPosition;
      currentIndex = Math.round(Math.abs(currentTranslate) / bildBreite);
      updateSliderHandle();
    }

    function handleDrag(deltaX, isHandle) {
      if (animationFrame) cancelAnimationFrame(animationFrame);
      animationFrame = requestAnimationFrame(function () {
        if (isHandle) updateHandlePosition(deltaX);
        else updateImagesPosition(deltaX);
      });
    }

    function onMove(event) {
      if (!isDraggingSlider && !isDragging) return;
      var x = event.touches ? event.touches[0].clientX : event.clientX;
      handleDrag(x - initialMouseX, isDraggingSlider);
      if (event.touches && event.cancelable) event.preventDefault();
      clickPrevented = true;
    }

    function startDragging(clientX, target) {
      isDragging = true;
      initialMouseX = clientX;
      if (target === handle) {
        isDraggingSlider = true;
        initialHandleCX = handle.getBoundingClientRect().left;
        handle.classList.add('grabbing');
        document.body.style.cursor = 'grabbing';
      }
      clickPrevented = false;
    }

    function stopDragging() {
      /* nur reagieren, wenn dieser Slider wirklich gezogen wurde */
      if (!isDragging && !isDraggingSlider) return;
      var warRegler = isDraggingSlider;
      isDraggingSlider = false;
      isDragging = false;
      handle.classList.remove('grabbing');
      if (warRegler) document.body.style.cursor = '';
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('touchmove', onMove);
      document.removeEventListener('mouseup', stopDragging);
      document.removeEventListener('touchend', stopDragging);
      clipToNearestImage();
      applyActiveToFullyDisplayedImage();
    }

    function onHandleStart(event) {
      var x = event.touches ? event.touches[0].clientX : event.clientX;
      startDragging(x, handle);
      document.addEventListener('mousemove', onMove);
      document.addEventListener('touchmove', onMove, { passive: false });
      document.addEventListener('mouseup', stopDragging);
      document.addEventListener('touchend', stopDragging);
      if (event.touches && event.cancelable) event.preventDefault();
    }
    handle.addEventListener('mousedown', onHandleStart);
    handle.addEventListener('touchstart', onHandleStart, { passive: false });

    imagesContainer.addEventListener('mousedown', function (event) {
      event.preventDefault();
      startDragging(event.clientX, event.target);
      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', stopDragging);
    });

    images.forEach(function (img) {
      img.addEventListener('click', function (event) {
        if (clickPrevented) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      });
      img.addEventListener('dragstart', function (event) { event.preventDefault(); });
    });

    function setPositionByIndex() {
      currentTranslate = currentIndex * -bildBreite;
      prevTranslate = currentTranslate;
      imagesWrapper.style.transform = 'translateX(' + currentTranslate + 'px)';
      updateSliderHandle();
    }

    function clearActiveTimeout() {
      if (activeTimeout) { clearTimeout(activeTimeout); activeTimeout = null; }
    }

    function applyActiveToFullyDisplayedImage() {
      clearActiveTimeout();
      activeTimeout = setTimeout(function () {
        var containerRect = imagesContainer.getBoundingClientRect();
        var fully = null;
        images.forEach(function (img) {
          var r = img.getBoundingClientRect();
          if (r.left >= containerRect.left && r.right <= containerRect.right) fully = img;
        });
        container.querySelectorAll('.image-item.active').forEach(function (e) { e.classList.remove('active'); });
        if (fully) fully.classList.add('active');
      }, 300);
    }

    function clipToNearestImage() {
      currentIndex = Math.round(Math.abs(currentTranslate) / bildBreite);
      setPositionByIndex();
    }

    function centerImage() {
      var containerRect = imagesContainer.getBoundingClientRect();
      var containerCenter = containerRect.width / 2;
      for (var i = 0; i < images.length; i++) {
        var r = images[i].getBoundingClientRect();
        if (r.left >= containerRect.left && r.right <= containerRect.right) {
          var deltaX = containerCenter - (r.left + r.right) / 2;
          currentTranslate += deltaX;
          imagesWrapper.style.transform = 'translateX(' + currentTranslate + 'px)';
          prevTranslate = currentTranslate;
          updateSliderHandle();
          return;
        }
      }
    }

    /* Wischen am Handy */
    imagesContainer.addEventListener('touchstart', function (event) {
      isTouchSwiping = true;
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
      initialMouseX = touchStartX;
      imagesWrapper.style.transition = '';
      clearActiveTimeout();
      clickPrevented = false;
    }, { passive: true });

    imagesContainer.addEventListener('touchmove', function (event) {
      if (!isTouchSwiping) return;
      var t = event.touches[0];
      var deltaX = t.clientX - touchStartX;
      var deltaY = t.clientY - touchStartY;
      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > THRESHOLD) {
        currentTranslate = prevTranslate + deltaX;
        imagesWrapper.style.transform = 'translateX(' + currentTranslate + 'px)';
        updateSliderHandle();
        if (event.cancelable) event.preventDefault();
        clickPrevented = true;
      }
    }, { passive: false });

    imagesContainer.addEventListener('touchend', function () {
      if (!isTouchSwiping) return;
      isTouchSwiping = false;
      /* ein einfacher Tipp (kein Wischen) aendert nichts an der Position */
      if (!clickPrevented) return;
      var movedBy = currentTranslate - prevTranslate;
      if (movedBy < -bildBreite / 15 && currentIndex < images.length - 1) currentIndex += 1;
      if (movedBy > bildBreite / 15 && currentIndex > 0) currentIndex -= 1;
      setPositionByIndex();
      imagesWrapper.style.transition = 'transform 0.3s ease-out';
      if (istMobil()) {
        clipToNearestImage();
        applyActiveToFullyDisplayedImage();
        centerImage();
      }
    });

    /* Maus loslassen im Slider (Desktop, nach Ziehen) */
    container.addEventListener('mouseup', function () {
      if (clickPrevented && istMobil()) {
        clipToNearestImage();
        applyActiveToFullyDisplayedImage();
        centerImage();
      }
    });

    function neuAusrichten() {
      messeBildBreite();
      updateVisibleImages();
      setPositionByIndex();
      if (istMobil()) {
        applyActiveToFullyDisplayedImage();
        centerImage();
      }
    }
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(neuAusrichten, 150);
    });
    if (document.readyState === 'complete') neuAusrichten();
    else window.addEventListener('load', neuAusrichten);

    messeBildBreite();
    updateVisibleImages();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
